"use client";

import background from "@/assets/images/homepage/background.png";

import Image from "next/image";
import { SystemuiChevronDownCircle } from "@/assets/icons/systemui-chevron-down-circle";
import Link from "next/link";
import { useState, useEffect } from "react";

export const HeroSection = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new window.Image();
    img.src = background.src;
    img.onload = () => {
      setImageLoaded(true);
    };
  }, []);

  return (
    <section
      id="hero-section"
      className="relative flex min-h-[100vh] w-full flex-col justify-end gap-24 overflow-x-hidden rounded-bl-3xl rounded-br-3xl bg-primary/45 bg-cover bg-center bg-no-repeat px-4 ph:px-24 md:px-48 lg:px-72 xl:px-96"
    >
      <div
        className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ${imageLoaded ? "opacity-100" : "opacity-0"}`}
        style={{ backgroundImage: `url(${background.src})` }}
      />

      <div
        className={`absolute inset-0 bg-primary/45 transition-opacity duration-1000 ${imageLoaded ? "opacity-0" : "opacity-100"}`}
      />

      <div className="absolute inset-0 bg-black/10" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/20 via-primary/10 to-black/55" />

      <div className="relative flex min-h-[calc(100vh-112px)] w-full flex-col justify-between py-12">
        <div className="flex flex-col items-center justify-center gap-5 md:gap-6">
          <div className="relative h-[112px] w-[112px] md:h-[140px] md:w-[140px]">
            <Image
              src="/images/logo-white.webp"
              alt="Logo"
              fill
              sizes="(max-width: 768px) 112px, 140px"
              className="object-contain"
              priority
            />
          </div>

          <div className="flex flex-col items-center justify-center gap-5 md:gap-9">
            <div className="flex flex-col items-center justify-center gap-1 md:gap-3">
              <h1 className="text-center text-4xl font-extrabold text-white [text-shadow:_0_2px_8px_rgb(0_0_0_/_0.45)] md:text-[3.25rem] xl:text-[3.7rem]">
                Espace Cadet
              </h1>
              <h2 className="text-base font-bold uppercase tracking-[0.18em] text-white [text-shadow:_0_2px_8px_rgb(0_0_0_/_0.45)] md:text-lg">
                Coworking & Bureaux
              </h2>
            </div>

            <div>
              <p className="text-center text-xl font-semibold text-white [text-shadow:_0_2px_12px_rgb(0_0_0_/_0.5)] md:text-2xl xl:text-4xl">
                Votre créativité mérite le meilleur espace.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-10 flex flex-col items-center justify-center gap-5 text-center md:mb-0">
          <p className="text-md font-medium text-white/95 [text-shadow:_0_2px_8px_rgb(0_0_0_/_0.55)]">
            Open space | Bureaux fermés | Salles de réunion | Cafétéria et
            phonebox
          </p>

          <Link
            href="/#place"
            className="rounded-full border border-white/70 bg-white/10 px-5 py-2 text-sm font-medium text-white backdrop-blur-sm transition-all hover:-translate-y-0.5 hover:bg-white/20"
          >
            Découvrir le lieu
          </Link>

          <Link
            href="/#place"
            className="group rounded-full p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
            aria-label="Descendre vers la section Le lieu"
          >
            <SystemuiChevronDownCircle className="h-11 w-11 text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.55)] transition-all duration-300 group-hover:scale-105 group-hover:text-white/80 motion-safe:animate-bounce md:h-12 md:w-12" />
          </Link>
        </div>
      </div>
    </section>
  );
};
